import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateContractRequest,
	postContracts,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const useCreateContractMutation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((contract: CreateContractRequest) =>
			postContracts(contract),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["contracts"] });
		},
	});
};
